/* import __COLOCATED_TEMPLATE__ from './detail-learnergroups-list.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { filter, map } from 'rsvp';
import { TrackedAsyncData } from 'ember-async-data';
import { mapBy, uniqueValues } from 'ilios-common/utils/array-helpers';
let DetailLearnerGroupsListComponent = (_class = class DetailLearnerGroupsListComponent extends Component {
  get treesData() {
    return new TrackedAsyncData(this.loadCohorts());
  }
  get isLoaded() {
    return this.treesData.isResolved;
  }
  get trees() {
    return this.treesData.isResolved ? this.treesData.value : [];
  }
  get learnerGroups() {
    return this.args.learnerGroups ?? [];
  }
  async loadCohorts() {
    if (!this.args.learnerGroups) {
      return [];
    }
    const cohorts = uniqueValues(await map(this.args.learnerGroups, async learnerGroup => {
      return learnerGroup.cohort;
    }));
    return map(cohorts, async cohort => {
      const groups = await filter(this.args.learnerGroups, async group => {
        const groupCohort = await group.cohort;
        return groupCohort === cohort;
      });
      const proxies = await Promise.all(groups.map(async group => {
        const title = await group.getTitleWithParentTitles();
        return {
          group,
          title
        };
      }));
      const sortedProxies = proxies.sort((a, b) => {
        const titleA = a.title.toLowerCase();
        const titleB = b.title.toLowerCase();
        return titleA > titleB ? 1 : titleA < titleB ? -1 : 0;
      });
      return {
        cohort,
        groups: mapBy(sortedProxies, 'group')
      };
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "treesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "treesData"), _class.prototype), _class);
export { DetailLearnerGroupsListComponent as default };